/**
*  料金シミュレーター
*
*  入所 & 入所（認知棟）
*
*  @since 2019.9.3
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_entrance = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階②　 ]
  income : [ 1750, 300, 390, 650, 1360 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  multi  : {
    four : [ 520, 0, 370, 370, 370 ],
    //two  : [ 0, 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  single : [ 3170, 1810, 1810, 2630, 2630 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1405, 2441, 3477  ],
        //two  : [ 0, 0, 0, 0, 0 ]
      },
      single : [ 1316, 2262, 3209 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1488, 2606, 3724 ],
          //two  : [ 0, 0, 0, 0, 0 ]
        },
      single : [ 1396, 2423, 3450 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1559, 2749, 3939 ],
          //two  : [ 0, 0, 0, 0, 0 ]
        },
      single : [ 1465, 2561, 3657 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1622, 2874, 4126 ],
          //two  : [ 0, 0, 0, 0, 0 ]
        },
      single : [ 1528, 2686, 3845 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1683, 2997, 4310 ],
          //two  : [ 0, 0, 0, 0, 0 ]
        },
      single : [ 1592, 2814, 4036 ]
    }
  ]
}

//入所（認知棟）
const array_entranceSub = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  income : [ 1750, 300, 390, 650, 1360 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  multi  : {
    four : [ 520, 0, 370, 370, 370],
    //two  : [ 0, 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  single : [ 1850, 490, 490, 1310, 1310 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1490, 2611, 3731 ],
        //two  : [ 0, 0, 0, 0, 0 ]
      },
      single : [ 1401, 2432, 3463 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1573, 2776, 3979 ],
          //two  : [ 0, 0, 0, 0, 0 ]
        },
      single : [ 1481, 2593, 3704 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1644, 2919, 4193 ],
          //two  : [ 0, 0, 0, 0, 0 ]
        },
      single : [ 1550, 2731, 3912 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1707, 3044, 4381 ],
          //two  : [ 0, 0, 0, 0, 0 ]
        },
      single : [ 1613, 2856, 4099 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1768, 3166, 4565 ],
          //two  : [ 0, 0, 0, 0, 0 ]
        },
      single : [ 1676, 2983, 4290 ]
    }
  ]
}


/**
*  function
*  動作
*/

// 入所
$( calcBtn.entrance ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.entrance ).serializeArray();
  const selectVal = selectCheck( currentForm.entrance, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_entrance.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_entrance.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_entrance.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }
    // 結果を出して表示する
    const result = ( array_entrance.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * 31;
    $( resultElm.entrance ).html( numberWithComma.format( result ) );
  } // end of 計算処理開始
return;
});



// 入所（認知棟）
$( calcBtn.entranceSub ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.entranceSub ).serializeArray();
  const selectVal = selectCheck( currentForm.entranceSub, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_entranceSub.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_entranceSub.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_entranceSub.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_entranceSub.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_entranceSub.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_entranceSub.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する

    const result = ( array_entranceSub.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * 31;
    $( resultElm.entranceSub ).html( numberWithComma.format( result ) );

  } // end of 計算処理開始

return;

});
